/**
 * KOLSprite — TikTok downloader, sort and analytics
 *
 * Declares three web-accessible-resource entries, none with `use_dynamic_url`. Two are
 * scoped to tiktok.com / kolsprite.com, but the first is matched to every origin and
 * exposes `src/assets/icon/*` and `src/assets/img/icon/*` — reachable at fixed URLs from
 * any page.
 *
 * The `src/assets/img/icon/collaborate.png` image is the primary signal, loaded through
 * `probeImage` with no CORS grant, corroborated by two files under the equally
 * every-origin `src/assets/icon/` path. All fire only when installed.
 *
 * Manifest verified against version 2.1.2.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'penohjgblobinadflplocjekaclnoemh';

export const kolsprite: ExtensionDefinition = {
  id: ID,
  name: 'TikTok Downloader, Sort & Analytics | KOLSprite',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Two WAR groups are site-scoped, but the src/assets icon group is on every origin ' +
    'with no dynamic URL, so it detects the extension from any page.',
  signals: [
    {
      id: 'war-collaborate-png',
      kind: 'web-accessible-resource',
      description:
        'Load src/assets/img/icon/collaborate.png via <img> — in the every-origin WAR ' +
        'group and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'src/assets/img/icon/collaborate.png'),
    },
    {
      id: 'war-iconfont-svg',
      kind: 'web-accessible-resource',
      description:
        'Load src/assets/icon/iconfont.svg via <img> — a second every-origin asset path.',
      weight: 0.5,
      run: () => probeImage(ID, 'src/assets/icon/iconfont.svg'),
    },
    {
      id: 'war-iconfont-css',
      kind: 'web-accessible-resource',
      description: 'Fetch src/assets/icon/iconfont.css — the icon-font stylesheet, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'src/assets/icon/iconfont.css'),
    },
  ],
};
